import {RefObject, useEffect, useRef} from "react";

/** Knowledge base defines a section as seen once half of it is in the viewport. */
const SECTION_VISIBILITY_THRESHOLD = 0.5;

interface IProps {
    isEnabled?: boolean;
    /** Re-arms the observer when it changes, e.g. after "Pokaż więcej" reveals new cards. */
    impressionKey?: string | number;
    onImpression: () => void;
}

/**
 * Fires a single impression once the observed element becomes visible, so
 * below-the-fold sections are not counted on page load.
 */
export const usePersonalizedHomepageImpression = <T extends HTMLElement = HTMLDivElement>(props: IProps): RefObject<T | null> => {
    const {isEnabled = true, impressionKey} = props;
    const elementRef = useRef<T>(null);
    const onImpressionRef = useRef(props.onImpression);

    onImpressionRef.current = props.onImpression;

    useEffect(() => {
        const element = elementRef.current;

        if (!isEnabled || !element) {
            return;
        }

        if (typeof IntersectionObserver === "undefined") {
            onImpressionRef.current();

            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) {
                    return;
                }

                observer.disconnect();
                onImpressionRef.current();
            },
            {threshold: SECTION_VISIBILITY_THRESHOLD}
        );

        observer.observe(element);

        return () => observer.disconnect();
    }, [isEnabled, impressionKey]);

    return elementRef;
};
import {RefObject, useEffect, useRef} from "react";

/** Knowledge base defines a section as seen once half of it is in the viewport. */
const SECTION_VISIBILITY_THRESHOLD = 0.5;

interface IProps {
    isEnabled?: boolean;
    /** Re-arms the observer when it changes, e.g. after "Pokaż więcej" reveals new cards. */
    impressionKey?: string | number;
    onImpression: () => void;
}

/**
 * Fires a single impression once the observed element becomes visible, so
 * below-the-fold sections are not counted on page load.
 */
export const usePersonalizedHomepageImpression = <T extends HTMLElement = HTMLDivElement>(props: IProps): RefObject<T | null> => {
    const {isEnabled = true, impressionKey} = props;
    const elementRef = useRef<T>(null);
    const onImpressionRef = useRef(props.onImpression);

    onImpressionRef.current = props.onImpression;

    useEffect(() => {
        const element = elementRef.current;

        if (!isEnabled || !element) {
            return;
        }

        if (typeof IntersectionObserver === "undefined") {
            onImpressionRef.current();

            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) {
                    return;
                }

                observer.disconnect();
                onImpressionRef.current();
            },
            {threshold: SECTION_VISIBILITY_THRESHOLD}
        );

        observer.observe(element);

        return () => observer.disconnect();
    }, [isEnabled, impressionKey]);

    return elementRef;
};
